import $ from 'jquery';
import 'slick-carousel';

ready(qs('.CP-gouv-wrapper'), () => {
    // ===== VARS =====
    const $cp = qs('.gouv-wrapper-slick');
    const $pushes = qsa($cp, 'li');
    const $wrapper = $('.gouv-wrapper-slick');
    const $plusBtn = qs('.CP-gouv-wrapper .CP-plus');
    let LIMIT_ITEMS = 5;
    const settings = {
        arrows: false,
        dots: false,
        variableWidth: true,
        infinite: false
    };

    // ===== FUNCTIONS ===== //
    const mobileBehavior = wrapper => {
        wrapper.slick(settings);
        wrapper.slicked = true;
    };
    const desktopBehavior = (wrapper) => {
        const displayPushes = (forceAll) => {
            let limit = (forceAll ? $pushes.length : LIMIT_ITEMS);
            let i = 0;
            for (; i < limit; i++) {
                if ($pushes[i]) {
                    $pushes[i].style.display = 'block';
                }
                else {
                    clearButton();
                }
            }
            if (!$pushes[i]) {
                clearButton();
            }
        }
        const clearButton = () => {
            $plusBtn.style.display = 'none'
            $pushes[$pushes.length - 1].style.marginBottom = "30px";
        }
        displayPushes(false);
        click($plusBtn, () => {
            displayPushes(true);
        })
        if (wrapper && wrapper.slicked) {
            $(wrapper).slick('unslick');
            wrapper.slicked = false;
        }
    }
    const behavior = () => {
        if (window.innerWidth < 1024) {
            mobileBehavior($wrapper);
        } else {
            desktopBehavior($wrapper);
        }
    }
    behavior();
    window.addEventListener('resize', () => {
        behavior()
    })
})




// WEBPACK FOOTER //
// ./src/scripts/components/GouvWrapper.js